<ng-container *ngIf="(menu$ | async) as menu">

    <ng-container *ngIf="modeService.mode === 'mobile'">
        <ng-container *ngIf="(mainSettings$ | async) as mainSettings">
          <ng-container *ngIf="(order$ | async) as order">
            <ng-container *ngIf="!(groupOrder$ | async) as groupOrder">
              <div class="start-group-order">
                <ng-container *ngIf="order?.location?.supportsGroupOrders && mainSettings?.show_group_order">
                  <button type="button"
                          class="de-secondary-btn group-order-prompt cursor-pointer"
                          (click)="startGroupOrder()"
                          aria-label="Start group order">
                    <i class="bi bi-people group-icon" aria-hidden="true"></i>
                    <span class="prompt-text">Group Order</span>
                  </button>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

<!--    <ng-container *ngIf="modeService.mode !== 'desktop'">-->
    <app-category-jump-nav
        [categories]="menu.categories"
    ></app-category-jump-nav>
<!--    </ng-container>-->
</ng-container>

<app-order-controls></app-order-controls>

<ng-container *ngIf="promotionalContent$ | async as promos">
    <ng-container *ngIf="navbarSettings$ | async as navbarSettings">
    <ng-container
            *ngIf="promos.menu_promotion_background_mobile || promos.menu_promotion_background">
      <app-promotional-content
              promoSection="menu"
              class="w-100 mt-3 d-flex"
              [ngClass]="navbarSettings.fixed_navbar_width ? 'ps-3 ps-lg-0 pe-3' : 'px-3'"              role="complementary"
              aria-label="Promotional content">
      </app-promotional-content>
    </ng-container>
    </ng-container>
  </ng-container>

<div class="category-list">
    <ng-container *ngIf="(mainSettings$ | async) as mainSettings">
        <ng-container *ngIf="(order$ | async) as order">
            <ng-container *ngIf="(menu$ | async) as menu">
                <ng-container *ngIf="(user$ | async) as user">
                    <ng-container
                            *ngFor="let category of (menu.categories | secretCategories: (user.isGuest ? roles.guest : roles.all) | daypartCategories: (showFullMenu$ | async)); let i = index; trackBy: categoryTrackBy">
                        <ng-container *ngIf="!category.isHidden && category.products && category.products.length">
                            <app-category-scroller
                                [category]="category"
                                [modifyModalRef]="modifyModalRef"
                                [productLoading]="menuService.productLoading"
                                [showFullMenu]="(!order?.location?.supportsGroupOrders || !mainSettings.show_group_order) && i === 0"
                                (clickCategory)="menuService.setCategory(category)"
                            ></app-category-scroller>
                        </ng-container>
                    </ng-container>
              </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</div>

<ng-template #modifyModal let-modal>
    <app-modify-modal [isLoading]="menuService.settingProduct" (closeModal)="modal.close()"></app-modify-modal>
</ng-template>
